import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/app.js";
import "./index.css"; // Optional: For global styles

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
